import { withLoading } from "hocs/withLoading";
import { lazy } from "react";

export { default as SupplierWallpaper } from "./SupplierWallpaper";
export { default as SupplierTabs } from "./SupplierTabs";
export { default as SuggestProducts } from "./SuggestProducts";
export const ExportCountries = withLoading(
  lazy(() => import("./ExportCountries"))
);
export { default as BaseSupplierInfors } from "./BaseSupplierInfors";
export const Verifications = withLoading(lazy(() => import("./Verifications")));
